import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import {
  WorkflowWaitScheduleRequest,
  WorkflowWaitScheduleResponse,
  WorkflowWaitResumeRequest,
  WorkflowWaitResumeResponse,
  WorkflowWaitPreviewRequest,
  WorkflowWaitPreviewResponse,
  WorkflowWaitQueueResponse,
  WorkflowWaitCancelRequest
} from '../models/workflow-wait.model';

@Injectable({ providedIn: 'root' })
export class WorkflowWaitApiService {
  private readonly apiUrl = `${environment.apiUrl}api/workflow-waits`;

  constructor(private http: HttpClient) {}

  schedule(
    enrollmentId: number,
    request: WorkflowWaitScheduleRequest
  ): Observable<WorkflowWaitScheduleResponse> {
    return this.http.post<WorkflowWaitScheduleResponse>(
      `${this.apiUrl}/enrollments/${enrollmentId}/schedule`, request
    );
  }

  resume(
    enrollmentId: number,
    request: WorkflowWaitResumeRequest = {}
  ): Observable<WorkflowWaitResumeResponse> {
    return this.http.post<WorkflowWaitResumeResponse>(
      `${this.apiUrl}/enrollments/${enrollmentId}/resume`, request
    );
  }

  processDue(includeActive?: boolean): Observable<WorkflowWaitResumeResponse[]> {
    let params = new HttpParams();
    if (includeActive !== undefined) {
      params = params.set('includeActive', includeActive.toString());
    }
    return this.http.post<WorkflowWaitResumeResponse[]>(`${this.apiUrl}/process-due`, {}, { params });
  }

  /**
   * INC_CRM_020 (4) inc3 — procesa solo las esperas marcadas en la tabla. La respuesta trae
   * una entrada por espera reanudada, que es lo que permite decir cuántas y cuáles.
   */
  processSelected(queueItemIds: number[]): Observable<WorkflowWaitResumeResponse[]> {
    return this.http.post<WorkflowWaitResumeResponse[]>(`${this.apiUrl}/process-selected`, { queueItemIds });
  }

  getQueue(filters?: {
    businessId?: number;
    status?: string;
    queueType?: string;
    workflowId?: number;
    enrollmentId?: number;
    /** INC_CRM_020 (6) inc3 — busca por NOMBRE del registro inscrito, no por su id. */
    recordSearch?: string;
  }): Observable<WorkflowWaitQueueResponse[]> {
    let params = new HttpParams();
    if (filters?.businessId)   params = params.set('businessId',   filters.businessId.toString());
    if (filters?.status)       params = params.set('status',       filters.status);
    if (filters?.queueType)    params = params.set('queueType',    filters.queueType);
    if (filters?.workflowId)   params = params.set('workflowId',   filters.workflowId.toString());
    if (filters?.enrollmentId) params = params.set('enrollmentId', filters.enrollmentId.toString());
    if (filters?.recordSearch) params = params.set('recordSearch', filters.recordSearch);
    return this.http.get<WorkflowWaitQueueResponse[]>(`${this.apiUrl}/queue`, { params });
  }

  preview(request: WorkflowWaitPreviewRequest): Observable<WorkflowWaitPreviewResponse> {
    return this.http.post<WorkflowWaitPreviewResponse>(`${this.apiUrl}/preview`, request);
  }

  cancel(queueItemId: number, request: WorkflowWaitCancelRequest = {}): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/${queueItemId}/cancel`, request);
  }
}
